import { render, staticRenderFns } from "./TransferBanner.vue?vue&type=template&id=8266db1e&"
import script from "./TransferBanner.vue?vue&type=script&lang=ts&"
export * from "./TransferBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports